export default function useWait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
